export class AzureCmkEligibleApp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "appRegistrationId",
            "baseName": "appRegistrationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "applicationClientId",
            "baseName": "applicationClientId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "applicationType",
            "baseName": "applicationType",
            "type": "string",
            "format": ""
        },
        {
            "name": "servicePrincipalId",
            "baseName": "servicePrincipalId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AzureCmkEligibleApp.attributeTypeMap;
    }
    constructor() {
    }
}
